// removed subscription cient
// remove websocketclient
import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { environment } from 'src/environments/environment';
import { InMemoryCache } from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';
import { AzureLoginService } from './azure-login.service';
import { CrmGraphql } from '../modules/crm/shared/constants/graphql-constants';
import { ApiConstants } from '../modules/crm/shared/constants/api.constant';

@Injectable({ providedIn: 'root' })
export class ApolloService {
  constructor(
    private apollo: Apollo,
    private httpLink: HttpLink,
    private azureService: AzureLoginService,
  ) {}

  private removeNamedClientIfExists(name: string): void {
    this.apollo.removeClient(name);
  }

  async createCRM() {
    this.removeNamedClientIfExists(CrmGraphql.NameSpace);
    this.removeNamedClientIfExists(CrmGraphql.QueryNameSpace);

    const link = this.httpLink.create({ uri: `${environment.baseScmApiUrl}/${ApiConstants.backend}` });
    const headerLink = setContext(() => ({
      uri: `${environment.baseScmApiUrl}/${ApiConstants.backend}`,
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.azureService.getAccessToken()}`,
      }),
    }));

    this.apollo.createNamed(CrmGraphql.NameSpace, {
      cache: new InMemoryCache(),
      link: headerLink.concat(link),
    });

    const linkQuery = this.httpLink.create({ uri: `${environment.baseScmApiUrl}/${ApiConstants.query}` });

    const headerLinkQuery = setContext(() => ({
      uri: `${environment.baseScmApiUrl}/${ApiConstants.query}`,
      headers: new HttpHeaders({
        Authorization: `Bearer ${this.azureService.getAccessToken()}`,
      }),
    }));
    this.apollo.createNamed(CrmGraphql.QueryNameSpace, {
      cache: new InMemoryCache(),
      link: headerLinkQuery.concat(linkQuery),
    });
  }

  closeWebSocketClient(): void {
    // no-op: legacy websocket subscription client was removed
  }
}
